/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Time_Modal_SubtitleInputs */

const en_workflow_time_modal_subtitle = /** @type {(inputs: Workflow_Time_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When did this happen? Defaults to now.`)
};

const ja_workflow_time_modal_subtitle = /** @type {(inputs: Workflow_Time_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつ発生しましたか？デフォルトは現在時刻です。`)
};

const fr_workflow_time_modal_subtitle = /** @type {(inputs: Workflow_Time_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand cela s’est-il produit ? Par défaut maintenant.`)
};

const de_workflow_time_modal_subtitle = /** @type {(inputs: Workflow_Time_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann ist es passiert? Standard ist jetzt.`)
};

/**
* | output |
* | --- |
* | "When did this happen? Defaults to now." |
*
* @param {Workflow_Time_Modal_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const workflow_time_modal_subtitle = /** @type {((inputs?: Workflow_Time_Modal_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Time_Modal_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_time_modal_subtitle(inputs)
	if (locale === "ja") return ja_workflow_time_modal_subtitle(inputs)
	if (locale === "fr") return fr_workflow_time_modal_subtitle(inputs)
	return de_workflow_time_modal_subtitle(inputs)
});